import { searchResultsExecutionStatus } from '@as-react/common-types';
import { MAX_NUMBER_OF_ARTICLES_IN_LISTER_PAGE_DEFAULT } from '../constants/ProductConstants';
import { NUMBER_OF_ITEMS_IN_LISTER_ROW_DESKTOP } from '../constants/ScreenWidthConstants';
import { getNbrOfItemsInListerRow } from './ScreenWidthUtil';
/*
 * returns the exact nbr of items to fit in the lister window
 * such that at the end of the last row there aren't any empty product tiles
 */
export const getListerItemsToShow = (items, pageSize, isClient) => {
    const numberOfItemsInRow = isClient ? getNbrOfItemsInListerRow() : NUMBER_OF_ITEMS_IN_LISTER_ROW_DESKTOP;
    if (items.length > (pageSize || MAX_NUMBER_OF_ARTICLES_IN_LISTER_PAGE_DEFAULT)) {
        return items.slice(0, items.length - (items.length % numberOfItemsInRow));
    }
    else {
        return items;
    }
};
export const isPartialSearchResult = (executionStatus) => executionStatus === searchResultsExecutionStatus.ALT_BRAND ||
    executionStatus === searchResultsExecutionStatus.ALT_QUERIES ||
    executionStatus === searchResultsExecutionStatus.ALT_SPELL_UNCHANGED;
/**
 * Parses category IDs from a defaultFilter string.
 * e.g. "categories:c(100;200;300)" → [100, 200, 300]
 */
export const parseCategoryIds = (defaultFilter) => {
    const startKey = 'categories:c(';
    const startIndex = defaultFilter.indexOf(startKey);
    if (startIndex === -1) {
        return [];
    }
    const endIndex = defaultFilter.indexOf(')', startIndex);
    return defaultFilter
        .substring(startIndex + startKey.length, endIndex)
        .split(';')
        .map(id => parseInt(id, 10))
        .filter(id => !isNaN(id));
};
